export class MailingListEntity {
    id;
    name;
    createdDate;
    createdBy;
    siteId;
    mailingListToUsers;

    constructor(id, name, createdDate, createdBy, siteId, mailingListToUsers = []) {
        this.id = id;
        this.name = name;
        this.createdDate = createdDate;
        this.createdBy = createdBy;
        this.siteId = siteId;
        this.mailingListToUsers = mailingListToUsers;
    }
}